import {PodState, PodValidationDeliveryType} from './pod-validation.model';
import {HttpParams} from '@angular/common/http';
import {Moment} from 'moment';

export interface PodValidationSearchCriteria {
  deliveryDateBefore?: Moment;
  deliveryDateAfter?: Moment;
  carriers: string[];
  regions: string[];
  loadOrDeliveryNumbers: string[];
  onlyRejected?: boolean;
  podState: PodState;
  type: PodValidationDeliveryType;
  podUploadedAfter?: Moment;
  podUploadedBefore?: Moment;
  originGlid: string[];
  destinationGlid: string[];
  page: number;
  pageSize: number;
}

export function podValidationSearchCriteriaToQueryParams(criteria: PodValidationSearchCriteria,
                                                         includePaginationCriteria: boolean = true
): HttpParams {

  let params = podValidationBasicSearchCriteriaToQueryParams(criteria, includePaginationCriteria);

  criteria.regions.forEach(regionId => params = params.append('regionIds', regionId));
  criteria.carriers.forEach(carrierId => params = params.append('carrierIds', carrierId));

  return params;
}

export function podValidationBasicSearchCriteriaToQueryParams(criteria: PodValidationSearchCriteria,
                                                              includePaginationCriteria: boolean = true
): HttpParams {

  let params = new HttpParams();

  criteria.loadOrDeliveryNumbers.forEach(number => params = params.append('loadOrDeliveryNumbers', number));
  if (criteria.onlyRejected) {
    params = params.set('onlyRejected', criteria.onlyRejected.toString());
  }
  if (criteria.podState) {
    params = params.set('podState', criteria.podState.toString());
  }
  if (criteria.type) {
    params = params.set('type', criteria.type.toString());
  }
  if (criteria.podUploadedAfter) {
    params = params.set('podUploadedAfter', criteria.podUploadedAfter.toISOString());
  }
  if (criteria.podUploadedBefore) {
    params = params.set('podUploadedBefore', criteria.podUploadedBefore.endOf('day').toISOString());
  }
  criteria.originGlid.forEach(glid => params = params.append('originGlid', glid));
  criteria.destinationGlid.forEach(glid => params = params.append('destinationGlid', glid));

  if (criteria.deliveryDateAfter) {
    params = params.set('deliveryDateAfter', criteria.deliveryDateAfter.toISOString());
  }
  if (criteria.deliveryDateBefore) {
    params = params.set('deliveryDateBefore', criteria.deliveryDateBefore.endOf('day').toISOString());
  }

  if (includePaginationCriteria) {
    params = params.set('page', (criteria.page - 1).toString());
    params = params.set('size', criteria.pageSize.toString());
  }

  return params;
}
